import type { FC } from "react";

import { useExpertUniversityConfiguration } from "@expert/expert-university";

import { usePartner } from "@/sdk";
import { useFeatureFlag } from "@/shared-utils";

import { ExpertUniversityLearningBlocks } from "./ascend/ExpertUniversityLearningBlocks";
import { ExpertUniversityHome } from "./ExpertUniversityHome";

/**
 * Routes the Expert University takeover to the right experience: experts in the ASCEND training pilot
 * (`EWP-isInASCENDTrainingPilot`) training on Verizon get the learning-blocks view, everyone else gets
 * the existing Expert University home. The check is on the *training* partner, not the expert's own,
 * so switching the training partner away from Verizon also leaves the learning-blocks view. Until the
 * flag resolves it is falsy, so home is the default (matching pre-pilot behavior).
 */
export const ExpertUniversityExperience: FC = () => {
    const partner = usePartner();
    const { trainingPartner } = useExpertUniversityConfiguration();
    const { data: isInAscendTrainingPilot } = useFeatureFlag<boolean>("EWP-isInASCENDTrainingPilot", { partner });

    return isInAscendTrainingPilot && trainingPartner === "verizon" ? (
        <ExpertUniversityLearningBlocks />
    ) : (
        <ExpertUniversityHome />
    );
};
